import React from 'react';
import Card from 'react-bootstrap/Card';
import withNameInput from './hoc-input';
import withNameSelect from './hoc-select';
import withNameCheckbox from './hoc-checkbox';
import Header from './header';
import Pane from './pane';

const Name = withNameInput('name');
const FundType = withNameSelect('fundType');
const DataProviderId = withNameInput('dataProviderId', 'data provider id');
const ISIN = withNameInput('isin', 'isin', true);
const ApirCode = withNameInput('apirCode', 'apir code');
const StockCode = withNameSelect('stockCode');
const Company = withNameSelect('company');
const Members = withNameSelect('members', 'team members', true);
const InvestorVehicleType = withNameInput('fundInvestorVehicleType', 'investor vehicle type', true);
const Wholesale = withNameCheckbox('wholesale', 'wholesale');
const Category = withNameInput('dpCategory', 'data provider category', true);
const Series = withNameSelect('series', 'series', true);

export default function BasicFields() {
  return (
    <Card>
      <Card.Header>
        <Header eventKey="basic">Basic</Header>
      </Card.Header>
      <Pane eventKey="basic">
        <Card.Body>
          <Name />
          <FundType />
          <Company />
          <ApirCode />
          <ISIN />
          <DataProviderId />
          <StockCode />
          <Members />
          <InvestorVehicleType />
          <Wholesale />
          <Category />
          <Series />
        </Card.Body>
      </Pane>
    </Card>
  );
}
